<template>
  <form class="update-address" ref="user_address" v-on:submit.prevent="setAddress()">
    <div class="card__header">
      <p class="card__title">Update address</p>
    </div>
    <div class="card__content">
      <div class="form">
        <div class="form__field">
          <label for="address" class="form__label">Enter your postcode</label>
          <div id="postcode_lookup"></div>
        </div>
        <div class="form__field">
          <div class="alert alert--notice alert--sm alert--warning">
            <p class="alert__title">Editing this field will cancel your existing orders. This ensures that everyone is delivered in due time, as your new address might change our delivery routes.</p>
          </div>
        </div>
        <div class="form__field" v-if="addressSelected">
          <label for="formatted_address_0" class="form__label">Address line 1</label>
          <input type="text" class="form__control form-field required" id="formatted_address_0" required v-model="$parent.address.line_1">
        </div>
        <div class="form__field form__field--md6" v-if="addressSelected">
          <label for="formatted_address_1" class="form__label">Address line 2</label>
          <input type="text" class="form__control" id="formatted_address_1" v-model="$parent.address.line_2">
        </div>
        <div class="form__field form__field--md6" v-if="addressSelected">
          <label for="formatted_address_2" class="form__label">Address line 3</label>
          <input type="text" class="form__control" id="formatted_address_2" v-model="$parent.address.line_3">
        </div>
        <div class="form__field form__field--md6 form__field--disabled" v-if="addressSelected">
          <label for="town_or_city" class="form__label">Town</label>
          <input type="text" class="form__control" id="town_or_city" required disabled v-model="$parent.address.city">
        </div>
        <div class="form__field form__field--md6 form__field--disabled" v-if="addressSelected">
          <label for="postcode" class="form__label">Postcode</label>
          <input type="text" class="form__control" id="postcode" required disabled v-model="$parent.address.postcode">
        </div>
        <div class="form__field">
          <label for="address_building-type" class="form__label">Building type</label>
          <select v-model="$parent.address.building_type" name="address_building-type" id="address_building-type" class="form__control form-field">
            <option value="house">House</option>
            <option value="flat">Flat</option>
            <option value="office">Office</option>
            <option value="shop">Shop</option>
          </select>
        </div>
        <div class="form__field">
          <label for="address_comments" class="form__label">Comments</label>
          <input v-model="$parent.address.comment" type="text" name="address_comments" id="address_comments" class="form__control form-field">
          <p class="form__notice">Anything relevant that would help us find you (special access, code, etc.)</p>
        </div>
      </div>
    </div>
    <div v-if="addressUpdating">
      <popup-loader></popup-loader>
    </div>
    <div class="card__actions">
      <button type="submit" class="button button--md button--secondary">Save</button>
    </div>
  </form>
</template>


<script>
export default {
  data() {
    return {
      addressUpdating: false,
      addressSelected: false,
    }
  },

  mounted() {
    window.getAddress.find(
        'postcode_lookup',
        window.config.getaddress_token,
        {
          input: {
            id:'address',
            name:'address',
            class:'form__control form-field required',
            label:'e.g. W12 0FD'
          },
          button:{
            class:'button button--md button--grey',
            label:'Search',
          },
          dropdown:{
            id:'address-select',
            class:'form__control form-field required',
            select_message:'Select your Address',
          },
        }
    );

    document.addEventListener("getaddress-find-address-selected",
      function (e) {
        const {
          thoroughfare,
          building_name,
          sub_building_name,
          sub_building_number,
          building_number,
          line_1,
          line_2,
          line_3,
          town_or_city,
          postcode,
          latitude,
          longitude,
        } = e.address;

        this.addressSelected = true;

        this.$parent.address = {
          ...this.$parent.address,
          building_type: line_1.toLowerCase().includes('flat') ? 'flat' : 'house',
          thoroughfare,
          building_name,
          sub_building_name,
          sub_building_number,
          building_number,
          line_1,
          line_2,
          line_3,
          city: town_or_city,
          postcode,
          coordinates: {
            latitude,
            longitude,
          },
        };
      }.bind(this))
  },

  methods: {
    setAddress: function () {
      if (!$(this.$refs.user_address).valid()) return false;

      // Loader
      this.addressUpdating = true;

      axios.post("/api/address/verify", {
        postcode: this.$parent.address.postcode,
      }).then(res => {
        if (res.data.canBeDelivered === false) {
          this.$parent.step = 'UNVALID';
        } else {
          axios.post(`/api/address/${this.$parent.address.id}`, {
            ...this.$parent.address,
            building_type: this.$parent.address.building_type,
            comment: this.$parent.address.comment,
          }).then(res => {
            this.$root.address = res.data.address

            if (res.data.orders_deleted === true) {
              this.$parent.step = 'VALID';
            }
            else {
              this.$root.accountAddress = 0;

              this.$root.alert = {
                type: "SUCCESS",
                title: "All good!",
                text: "Your address has been saved.",
              };
            }

            this.addressUpdating = false;
          }).catch(err => {
            this.$root.alert = {
              type: "ERROR",
              title: "Oops!",
              text: "Something went wrong. Please try again.",
            };

            this.addressUpdating = false;
          });
        }
      }).catch(error => console.log(error));

      return false;
    },
  }
}
</script>
